import { ApolloClient } from '@apollo/client';

import {
  ActivitiesContentType,
  LanguageCodes,
  LESSON_ACTIVITIES,
} from 'global/constants';

export function updatePrintAssetsInCache({
  client,
  contentId,
  contentType,
  language,
  assetKeys,
  version,
}: {
  client: ApolloClient<any>;
  contentId: number;
  contentType: ActivitiesContentType;
  language: LanguageCodes;
  assetKeys: {
    __typename: 'AssetKey';
    language: LanguageCodes;
    key: string;
    publicToken: string | null;
  }[];
  version: string;
}) {
  client.cache.modify({
    id: client.cache.identify({
      __typename:
        contentType === LESSON_ACTIVITIES
          ? 'LessonActivities'
          : 'AssessmentActivities',
      id: contentId,
      language,
      version,
    }),
    fields: {
      assetKeys: (existing: any) => {
        return {
          ...existing,
          print: assetKeys,
        };
      },
    },
  });
}
